module.exports = __webpack_public_path__ + "static/raman-1eb6b064e3c2e81f87620978c7315a3e.jpg";